import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [mode, setModeState] = useState(localStorage.getItem("andil_mode") || "worker");

  const setMode = useCallback((m) => {
    setModeState(m);
    localStorage.setItem("andil_mode", m);
  }, []);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("andil_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("andil_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("andil_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("andil_token", data.token);
    setUser(data.user);
    if (payload.intent) setMode(payload.intent);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("andil_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, mode, setMode, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
